module.exports = "/assets/images/logo-pre.04fe5324.png";